<template>
  <div>
    <el-dialog
        title="修改登录密码"
        :visible.sync="dialogVisible"
        width="450px"
        :before-close="handleClose"
        @close="handleClose"
        :close-on-click-modal="false"
    >
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            class="demo-ruleForm"
        >
            <el-form-item prop="oldPassword" label="旧密码">
                <el-input show-password v-model="ruleForm.oldPassword" placeholder="请输入原8-16位登录密码"></el-input>
            </el-form-item>
            <el-form-item prop="newPassword" label="新密码">
                <el-input show-password v-model="ruleForm.newPassword" placeholder="请输入新8-16位登录密码"></el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword" label="确认密码">
                <el-input show-password v-model="ruleForm.confirmPassword" placeholder="请再次输入登录密码"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button class="sub-button" :disabled="loading" type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import account from "@/store/modules/account";

export default {
  data() {
      const validNewPass = (rule, value, callback) => {
          let reg = /(?!^(\d+|[A-Z]+|[a-z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,16}$/;
          if (value === "") {
              callback(new Error("请输入新8-16位登录密码"));
          } else if (!reg.test(value)) {
              callback(new Error("密码长度为8-16位;必须包含大写字母、小写字母、数字和特殊字符中的两种或以上"));
          } else {
              if (this.ruleForm.confirmPassword !== "") {
                  this.$refs.ruleForm.validateField("confirmPassword");
              }

              callback();
          }
      };

      const validatePass2 = (rule, value, callback) => {
          if (value === "" || value == undefined) {
              callback(new Error("请再次输入登录密码"));
          } else if (value !== this.ruleForm.newPassword) {
              callback(new Error("两次输入密码不一致!"));
          } else {
              callback();
          }
      };
      return {
          dialogVisible: false,
          ruleForm: {
              oldPassword: undefined,
              newPassword: undefined,
              confirmPassword: undefined
          },
          rules: {
              oldPassword: [
                  {required: true, message: '请输入原登录密码', trigger: "blur"}
              ],
              newPassword: [
                  {required: true, validator: validNewPass, trigger: "blur"}
              ],
              confirmPassword: [
                  {required: true, validator: validatePass2, trigger: "blur"}
              ]
          },

          loading: false
      };
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    submitForm() {
        this.$refs.ruleForm.validate(async valid => {
            if (valid) {
                if (this.loading) return
                this.loading = true

                this.$http.post(this.$api.user.changePassword, {
                    "oldCode": this.ruleForm.oldPassword,
                    "newCode": this.ruleForm.newPassword,
                }).then(res => {
                    if (res.data.code == 200) {
                        this.handleClose();
                        this.$store.dispatch('account/logout')
                        window.location.href = 'http://sign.lngsyz.com/#/login'
                        // this.$router.push({path: "/login"})
                    } else {
                        this.$message.error(res.data.msg);
                    }

                    this.loading = false
                });
            }
      });
    },
    handleClose() {
      this.loading = false;
      this.$refs.ruleForm.resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.sub-button {
  width: 138px;
  height: 42px;
  font-size: 16px;
}
::v-deep .el-dialog__body {
  padding: 20px 30px 0;
}
::v-deep .el-dialog__footer {
  text-align: center !important;
}
::v-deep .el-form-item {
  margin-bottom: 28px !important;
}
::v-deep .el-form-item__error {
  text-align: left !important;
}
</style>
